import axios from "axios";

export const client = axios.create({
    baseURL: process.env.REACT_APP_API_SERVER_URL + "/"
});


let helpers = {};

helpers.getAccessTokenSilently = null;
helpers.getAccessTokenWithPopup = null;


export function loadToken({getAccessTokenSilently, getAccessTokenWithPopup}){
    // console.log(client)
    helpers.getAccessTokenSilently = getAccessTokenSilently;
    helpers.getAccessTokenWithPopup = getAccessTokenWithPopup;
}

async function getToken(){

  let options = {
    authorizationParams: {
      audience: `https://nucleus.mercuryinnovation.com.au`
    },
  };

  let token;

  try{
    token = await helpers.getAccessTokenSilently(options);
  }
  catch(e){
    token = await helpers.getAccessTokenWithPopup(options);
  }

  return token;
}

client.interceptors.request.use(async function (config) {
    const token = await getToken();
    config.headers.Authorization = `Bearer ${token}`;
     
    return config;
});